"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faArrowLeft_1 = require("@fortawesome/pro-light-svg-icons/faArrowLeft");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var get_1 = __importDefault(require("lodash/fp/get"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var FilteredTable_1 = __importDefault(require("containers/TableMaker/FilteredTable"));
var filter_1 = require("utils/filter");
var tableConf_1 = __importDefault(require("./tableConf"));
// export const RECHARGE_IMPORTS_TABS = [
//   { label: 'For Review', href: '/recharges/imports/for-review' },
//   { label: 'All', href: '/recharges/imports/all' },
// ];
// const FILTER_MAP: Record<string, (rechImport: PopRechargeImport) => boolean | undefined> = {
//   'for-review': (rechImport) => rechImport.uploadRequirements?.needsUpload,
//   all: () => true,
// };
var Table = (0, FilteredTable_1.default)(tableConf_1.default, [
    (0, filter_1.makeGroupDef)('Vendor', function (item) { return item.rechVendor.name; }),
    (0, filter_1.makeGroupDef)('Rule', function (item) { return item.isExcluded ? 'Excluded' : 'Included'; }),
], [(0, get_1.default)('rechVendor.name'), (0, get_1.default)('name')]);
var ExcludedPlans = function () { return ((0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ height: 1, pb: 2, width: 1060 }, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Recharges - Excluded Plans", description: "Recharges - Excluded Plans" }), (0, jsx_runtime_1.jsx)(Table, { toolbarProps: { justifyContent: 'space-between', width: 1038 }, toolbarContent: {
                pre: (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ size: "small", color: "neutral", icon: faArrowLeft_1.faArrowLeft, url: "/recharges/charges" }, { children: "Go back" })),
            } })] }))); };
exports.default = ExcludedPlans;
